// src/components/ClerkProviderWithRouter.tsx
// A Clerk a react-router navigate()-jét használja, így a /profile alatti
// fülek (Biztonság, Előfizetés...) nem töltik újra az oldalt, és nem visznek máshova.
import React from "react";
import { useNavigate } from "react-router-dom";
import { ClerkProvider } from "@clerk/clerk-react";
import { huHU } from "@clerk/localizations";

interface Props {
    publishableKey: string;
    children: React.ReactNode;
}

const ClerkProviderWithRouter: React.FC<Props> = ({ publishableKey, children }) => {
    const navigate = useNavigate();

    return (
        <ClerkProvider
            publishableKey={publishableKey}
            localization={huHU}
            routerPush={(to) => navigate(to)}
            routerReplace={(to) => navigate(to, { replace: true })}
        >
            {children}
        </ClerkProvider>
    );
};

export default ClerkProviderWithRouter;